<script>
import Dropdown from '@components/dropdown.vue'

export default {
  components: {
    Dropdown,
  },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    search: null,
  }),
  computed: {
    filteredItems() {
      return this.items.filter((item) =>
        `${item.name}|${item.address}`
          .toLowerCase()
          .includes(this.search.toLowerCase())
      )
    },
    dropdownVisible() {
      return this.search && this.search.length
    },
  },
  methods: {
    handleSelect(item) {
      this.search = ''
      this.$emit('select', item)
    },
    handleFocus() {
      this.search = ''
      this.$emit('focus')
    },
  },
}
</script>

<template>
  <div class="search">
    <BaseInputText
      v-model="search"
      :placeholder="placeholder"
      @focus="handleFocus"
    />
    <Transition name="appear">
      <Dropdown
        v-if="dropdownVisible"
        :list="filteredItems"
        @select="handleSelect"
      />
    </Transition>
  </div>
</template>
